import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.png'
import Projects from '../../api/projects';

const ProjectPage = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header wpo-header-style-4'} Logo={Logo} />
            <PageTitle pageTitle={'Projets'} pagesub={'Projets'}  />
            <section className='wpo-project-area s4 section-padding'>
                <div className="container">
                    <div className="wpo-project-wrap">
                        <div className="row ">
                            {Projects.slice(0, 5).map((project, index) => (
                                <div className="col-lg-4 col-md-6 col-12" key={index}>
                                    <div className="wpo-project-item">
                                        <div className="wpo-project-img n" style={{ marginTop: '20px' }}>
                                            <img src={project.pimg} alt="" />
                                            <div className="thumb">
                                                <h4>{project.id}</h4>
                                            </div>
                                        </div>
                                        <div className="wpo-project-text">
                                            <h2><span>{project.title}</span></h2>
                                            <span>{project.subtitle}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
            <Footer hclass={'wpo-site-footer'} />
            <Scrollbar />
        </Fragment>
    )
};
export default ProjectPage;
